import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { InstagramOutlined, FacebookFilled, CheckCircleOutlined, CommentOutlined, ExclamationCircleFilled, EyeInvisibleOutlined, DeleteOutlined, LoadingOutlined, CloseCircleOutlined, SendOutlined, ClockCircleOutlined, WarningOutlined, MoneyCollectTwoTone, GlobalOutlined, ExclamationCircleOutlined, ShopFilled, ShopOutlined, MailOutlined, BranchesOutlined, LinkOutlined, DollarCircleOutlined, VideoCameraOutlined, ApartmentOutlined, CopyOutlined, TwitterOutlined, SafetyCertificateOutlined, UserOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Popover, Switch, Breadcrumb, Drawer, Button, Space, Modal, Tabs, message, Spin, Statistic, Row, Col, Table, Tag, Tooltip, Alert, Card, Empty, Flex, Result, Steps, Checkbox, Avatar } from 'antd';
import CountUp from 'react-countup';
import { AutoReply, AutoHide, AutoDelete } from "../../comps/automate/main";
import { useParams } from 'react-router';
import callAPI from "../../comps/fetch/main";
import { LinuxOutlined } from '@ant-design/icons';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { BsCursor } from "react-icons/bs";

import generateInsights from "../../funcs/genrateInsights";
import { ShopifyAutomate } from "../../comps/automateShopify/main";

import { Timeline } from "antd";
import dayjs from "dayjs";
import AccessOrNot from "../../funcs/accessOrNot";
import CrownReturn from "../../comps/crownPremium/main";
import { fireDB, fireSTORAGE } from "../../funcs/firebase";
import { addDoc, collection, serverTimestamp, getDocs, query, where, deleteDoc, doc, updateDoc, getDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Form, Input, List, Popconfirm } from "antd";
import { BookOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';



function StatusTimeline({ timeline = [] }) {
    return (
        <Timeline mode="left" style={{ marginTop: 16 }}>
            {timeline.map((entry, index) => {
                const currentTime = dayjs.utc(entry.timestamp).local()
                const prevTime = index > 0 ? dayjs(timeline[index - 1].timestamp) : null;
                const diffMinutes = prevTime ? currentTime.diff(prevTime, "minute") : null;

                return (
                    <Timeline.Item key={index}>
                        <div style={{ fontWeight: 600 }}>{entry.status}</div>
                        <div style={{ fontSize: 12, color: "#888" }}>
                            {currentTime.format("YYYY-MM-DD hh:mm A")}
                        </div>
                        {/* {diffMinutes !== null && (
              <div style={{ fontSize: 12, color: "#aaa" }}>
                ⏱ +{diffMinutes} min
              </div>
            )} */}
                    </Timeline.Item>
                );
            })}
        </Timeline>
    );
}



const PostPreview = ({ igDetail, fbDetail, onLinkFacebook, hideFacebook }) => {
    return (
        <div
            style={{
                // maxWidth: 700,
                margin: "0",
                padding: "0px 16px",
                background: "#fff",
                borderRadius: 16,
                marginTop: "20px",
                // boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "flex",
                alignItems: "center",
                gap: "10px"
            }}
        >
            {!hideFacebook &&
                <>
                    <p style={{ opacity: ".5", margin: 0, marginRight: "auto" }}>
                        Changes will be updated on both Instagram and Facebook if Linked.
                    </p>

                    <div style={{ display: "flex", gap: "10px" }}>
                        {igDetail?.media_url && (
                            <Popover
                                content={
                                    <img
                                        src={igDetail?.thumbnail_url || igDetail?.media_url}
                                        alt="Instagram"
                                        style={{
                                            width: "auto",
                                            maxHeight: 200,
                                            borderRadius: 8,
                                            objectFit: "cover",
                                        }}
                                    />
                                }
                                title="Instagram Post"
                                trigger="hover"
                            >
                                <div
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderRadius: "50%",
                                        background: "linear-gradient(145deg, rgba(255,245,250,0.6), rgba(250,240,255,0.6))",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "1px solid #f0f0f0"
                                    }}
                                >
                                    <InstagramOutlined style={{ fontSize: "24px", color: "#E1306C" }} />
                                </div>
                            </Popover>
                        )}

                        <Popover
                            content={
                                fbDetail?.full_picture ? (
                                    <img
                                        src={fbDetail.full_picture}
                                        alt="Facebook"
                                        style={{
                                            width: "auto",
                                            maxHeight: 200,
                                            borderRadius: 8,
                                            objectFit: "cover",
                                        }}
                                    />
                                ) : (
                                    <div style={{ textAlign: "center", padding: "10px" }}>
                                        <Empty
                                            description={<span style={{ fontSize: 12 }}>No Facebook post</span>}
                                            imageStyle={{ height: 40 }}
                                        />
                                        <Button
                                            type="primary"
                                            size="small"
                                            style={{ marginTop: 8, borderRadius: "4px" }}
                                            onClick={AccessOrNot("fb_automation") ? () => onLinkFacebook() : () => { }}
                                        >
                                            Link Facebook Post <CrownReturn premiumUser={AccessOrNot("fb_automation")} />
                                        </Button>
                                    </div>
                                )
                            }
                            title="Facebook Post"
                            trigger="hover"
                        >
                            <div
                                style={{
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderRadius: "50%",
                                    background: "linear-gradient(145deg, rgba(240,250,255,0.6), rgba(230,240,255,0.6))",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: "1px solid #f0f0f0"
                                }}
                            >
                                <FacebookFilled style={{ fontSize: "24px", color: "#1877F2" }} />
                            </div>
                        </Popover>

                    </div>
                </>
            }

            {hideFacebook && igDetail && (
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', width: '100%', padding: '10px 0' }}>
                    <div style={{ flexShrink: 0 }}>
                        {igDetail.media_type === "VIDEO" ? (
                            <video
                                src={igDetail.media_url}
                                style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8 }}

                            />
                        ) : (
                            <img
                                src={igDetail.thumbnail_url || igDetail.media_url}
                                alt="Post thumbnail"
                                style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8 }}
                            />
                        )}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            <h4 style={{ margin: 0 }}>{igDetail.username ? `@${igDetail.username}` : 'Instagram Post'}</h4>
                            <span style={{ fontSize: '12px', color: '#888' }}>
                                {new Date(igDetail.timestamp).toLocaleDateString()}
                            </span>
                        </div>
                        <p style={{
                            margin: '0 0 8px 0',
                            color: '#555',
                            fontSize: '14px',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }}>
                            {igDetail.caption}
                        </p>
                        <div style={{ display: 'flex', gap: '16px', fontSize: '13px', color: '#666' }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <CheckCircleOutlined /> {igDetail.like_count || 0} Likes
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <CommentOutlined /> {igDetail.comments_count || 0} Comments
                            </span>
                        </div>
                    </div>
                    <div style={{ marginLeft: 'auto' }}>
                        <a href={igDetail.permalink} target="_blank" rel="noreferrer">
                            <Button icon={<LinkOutlined />} size="small">View on IG</Button>
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

const formatter = (value) => <CountUp end={value} separator="," />;
const { confirm } = Modal;

function Automations() {
    const [messageApi, contextHolder] = message.useMessage();

    const [showDrawer, setShowDrawer] = useState(false)
    const [DrawerType, setDrawerType] = useState("")
    const [toogle, setToogle] = useState(true)

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState()
    const [initalState, setInitalState] = useState()
    const params = useParams()
    const location = useLocation();

    const [callPostAPi, setCallPostApi] = useState(false)
    const [posting, setPosting] = useState(false)
    const [dataPostedState, setDataPostedState] = useState()
    const [disableSection, setDisableSection] = useState()
    const [dashboardAPIData, setDashboardAPIData] = useState()

    const [postComments, setPostComments] = useState()

    const [postCommentsList, setPostCommentsList] = useState([])
    const [commentsLoading, setCommentsLoading] = useState(false)

    const [commentPagination, setCommentPagination] = useState()

    let user_detail = JSON.parse(localStorage.getItem("userData"));


    // --- Collab Request Review Logic ---
    const [searchParams] = useSearchParams();
    const inviteId = searchParams.get('invite_id');
    const action = searchParams.get('action');

    const [reviewModalOpen, setReviewModalOpen] = useState(false);
    const [reviewInviteData, setReviewInviteData] = useState(null);
    const [reviewPermissions, setReviewPermissions] = useState({
        view_automation: true,
        edit_automation: true,
        view_contacts: true
    });
    const [reviewProcessing, setReviewProcessing] = useState(false);
    const [updatingAccess, setUpdatingAccess] = useState(false);

    // Edit Permissions State
    const [editPermissionsModalOpen, setEditPermissionsModalOpen] = useState(false);
    const [editPermissions, setEditPermissions] = useState({
        view_automation: false,
        edit_automation: false,
        view_contacts: false
    });
    const [editingCollaborator, setEditingCollaborator] = useState(null);

    useEffect(() => {
        if (inviteId && action === 'review') {
            const fetchInvite = async () => {
                try {
                    const d = await getDoc(doc(fireDB, "collab_invitations", inviteId));
                    if (d.exists()) {
                        const data = d.data();
                        if (data.status === 'pending') {
                            setReviewInviteData({ id: d.id, ...data });
                            setReviewModalOpen(true);
                        }
                    }
                } catch (e) {
                    console.error("Error fetching invite for review:", e);
                }
            }
            fetchInvite();
        }
    }, [inviteId, action]);

    const handleAcceptRequest = async () => {
        if (!reviewInviteData) return;
        try {
            setReviewProcessing(true);
            const docRef = doc(fireDB, "collab_invitations", reviewInviteData.id);
            let user_detail = JSON.parse(localStorage.getItem("userData"));

            // Map permissions to API format
            let accessList = [];
            if (reviewPermissions.view_contacts) accessList.push("contacts_view");
            if (reviewPermissions.view_automation) accessList.push("configuration_view");
            if (reviewPermissions.edit_automation) accessList.push("configuration_edit");

            // Call API
            const apiPayload = {
                post_id: reviewInviteData.post.id,
                access: accessList,
                owner_id: user_detail?.user_id,
                requester_id: reviewInviteData.sender.uid, // Using created_by_uid as requester ID
                approved: true
            };

            callAPI({
                url: "ig_collab_access", method: "PUT",
                loadingState: setUpdatingAccess,
                body: apiPayload,
                dataState: async (res) => {
                    if (res?.code === 200) {
                        message.success("Request accepted successfully!");
                        setReviewModalOpen(false);
                        await updateDoc(docRef, {
                            status: "accepted",
                            accepted_at: serverTimestamp(),
                            accepted_by_uid: user_detail?.user_id,
                            permissions: reviewPermissions
                        });
                        // Clear URL params
                        window.history.replaceState({}, document.title, window.location.pathname);
                        // Reload to reflect changes if necessary
                        window.location.reload();
                    } else {
                        message.error("Failed to accept request.");
                    }
                }
            }
            );

        } catch (err) {
            console.error("Error accepting request:", err);
            message.error("Failed to accept request.");
        } finally {
            setReviewProcessing(false);
        }
    };

    const handleUpdatePermissions = async () => {
        if (!editingCollaborator) return;
        try {
            setUpdatingAccess(true);
            const docRef = doc(fireDB, "collab_invitations", editingCollaborator.id);
            let user_detail = JSON.parse(localStorage.getItem("userData"));

            // Map permissions to API format
            let accessList = [];
            if (editPermissions.view_contacts) accessList.push("contacts_view");
            if (editPermissions.view_automation) accessList.push("configuration_view");
            if (editPermissions.edit_automation) accessList.push("configuration_edit");

            let targetUserId = editingCollaborator.sender?.uid;
            if (editingCollaborator.sender?.uid === user_detail?.user_id) {
                targetUserId = editingCollaborator.accepted_by_uid;
            }

            const apiPayload = {
                post_id: editingCollaborator.post.id,
                access: accessList,
                owner_id: user_detail?.user_id,
                requester_id: targetUserId,
                approved: true
            };

            callAPI({
                url: "ig_collab_access", method: "PUT",
                loadingState: setUpdatingAccess,
                body: apiPayload,
                dataState: async (res) => {
                    if (res?.code === 200) {
                        message.success("Permissions updated successfully!");
                        setEditPermissionsModalOpen(false);
                        await updateDoc(docRef, {
                            permissions: editPermissions
                        });
                        // Update local state
                        setCollaborators(prev => prev.map(c => c.id === editingCollaborator.id ? { ...c, permissions: editPermissions } : c));
                    } else {
                        message.error("Failed to update permissions.");
                    }
                }
            });

        } catch (err) {
            console.error("Error updating permissions:", err);
            message.error("Failed to update permissions.");
        } finally {
            setUpdatingAccess(false);
        }
    };

    const handleDeclineRequest = async () => {
        if (!reviewInviteData) return;
        try {
            setReviewProcessing(true);
            const docRef = doc(fireDB, "collab_invitations", reviewInviteData.id);
            await updateDoc(docRef, {
                status: "declined",
                declined_at: serverTimestamp()
            });
            message.info("Request declined.");
            setReviewModalOpen(false);
            window.history.replaceState({}, document.title, window.location.pathname);
        } catch (err) {
            console.error(err);
        } finally {
            setReviewProcessing(false);
        }
    }
    // ------------------------------------

    const [collaborators, setCollaborators] = useState([]);

    const [currentUserPermissions, setCurrentUserPermissions] = useState({
        view_automation: false,
        edit_automation: false,
        view_contacts: false,
        is_owner: false
    });

    useEffect(() => {
        if (!params.id) return;
        const fetchCollaborators = async () => {
            try {
                const q = query(
                    collection(fireDB, "collab_invitations"),
                    where("post.id", "==", params.id)
                );
                const snapshot = await getDocs(q);
                const list = [];
                snapshot.forEach(d => list.push({ id: d.id, ...d.data() }));
                setCollaborators(list);

                // Determine permissions for current user


                let user_detail = {};
                try {
                    user_detail = JSON.parse(localStorage.getItem("userData")) || {};
                } catch (e) { }
                let is_owner = igDetail?.owner_id === user_detail?.user_id;

                const myInvite = list.find(c =>
                    c.sender?.uid === user_detail?.user_id && c.status === 'accepted'
                );


                if (myInvite && myInvite.permissions) {
                    setCurrentUserPermissions({ ...myInvite.permissions, is_owner: false });
                } else {
                    // Default to full permissions (Owner or no restrictions found)
                    setCurrentUserPermissions({
                        view_automation: true,
                        edit_automation: true,
                        view_contacts: true,
                        is_owner: is_owner
                    });
                }

            } catch (e) {
                console.error("Error fetching collaborators:", e);
            }
        }
        fetchCollaborators();
    }, [params.id]);

    const [commentPaginationPageChange, setCommentPaginationPageChange] = useState(0)

    const [showPlan, setShowPlan] = useState(false)

    const [showAccountWaring, setShowAccountWaring] = useState(false)

    const [igDetail, setIGDetail] = useState({})
    const [fbDetail, setFBDetail] = useState({})
    const [selectedFBDetail, setSelectedFBDetail] = useState()

    const [checkingAccess, setCheckingAccess] = useState(false)
    const [creatorStatus, setCreatorStatus] = useState(null) // null, 'on_idm', 'not_on_idm'
    const [showInviteModal, setShowInviteModal] = useState(false);
    const [inviteLink, setInviteLink] = useState(null);
    const [generatingLink, setGeneratingLink] = useState(false);
    const [inviteMessage, setInviteMessage] = useState("");

    const checkCreatorAccess = () => {
        if (!igDetail?.username) return;

        // If already checked and not on idm, trigger invite again
        if (creatorStatus === 'not_on_idm') {
            inviteCreator();
            return;
        }

        callAPI({
            url: `is_on_idm?username=${igDetail.username}`,
            method: "GET",
            loadingState: setCheckingAccess,
            dataState: (res) => {
                if (res?.data?.is_on_idm) {
                    setCreatorStatus('on_idm');
                    inviteCreator(true);
                } else {
                    setCreatorStatus('not_on_idm');
                    inviteCreator(false);
                }
            }
        })
    }

    const generateInviteLink = async () => {
        if (inviteLink) return inviteLink;

        try {
            setGeneratingLink(true);
            let userData = JSON.parse(localStorage.getItem("userData"));

            // Check for existing invitation
            const q = query(
                collection(fireDB, "collab_invitations"),
                where("sender.uid", "==", userData?.user_id),
                where("post.id", "==", igDetail?.id)
            );
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const existingDoc = querySnapshot.docs[0];
                const link = `https://app.instantdm.com/c/${existingDoc.id}`;
                setInviteLink(link);
                setGeneratingLink(false);
                return link;
            }

            // 1. Handle Image Upload
            let imageUrl = igDetail?.thumbnail_url || igDetail?.media_url;
            let fireStorageUrl = imageUrl;

            if (imageUrl) {
                try {
                    const proxyUrl = `https://imagecorsworkers.sanjayhotaction.workers.dev/${encodeURIComponent(imageUrl)}`;
                    const response = await fetch(proxyUrl);
                    if (!response.ok) throw new Error("Proxy fetch failed");

                    const blob = await response.blob();
                    const storageRef = ref(fireSTORAGE, `invites/${igDetail.id}_${Date.now()}.jpg`);
                    await uploadBytes(storageRef, blob);
                    fireStorageUrl = await getDownloadURL(storageRef);
                } catch (e) {
                    console.error("Image upload failed even with proxy, using original url", e);
                    fireStorageUrl = imageUrl;
                }
            }

            // 2. Store Data
            const docRef = await addDoc(collection(fireDB, "collab_invitations"), {
                sender: {
                    uid: userData?.user_id,
                    username: userData?.username || userData?.name || "User", // Fallback
                    picture: userData?.picture || null
                },
                post: {
                    id: igDetail?.id,
                    url: igDetail?.permalink,
                    caption: igDetail?.caption || "",
                    image: fireStorageUrl,
                    username: igDetail?.username
                },
                owner_username: igDetail?.username,
                owner_on_idm: creatorStatus === 'on_idm',
                created_at: serverTimestamp(),
                status: "pending"
            });

            const link = `https://app.instantdm.com/c/${docRef.id}`;
            setInviteLink(link);
            setGeneratingLink(false);
            return link;

        } catch (err) {
            console.error(err);
            setGeneratingLink(false);
            message.error("Failed to generate invite link");
            return null;
        }
    }

    const inviteCreator = async (isOnIdm) => {
        setShowInviteModal(true);

        let defaultMsg = "";
        if (isOnIdm) {
            defaultMsg = `Hey @${igDetail?.username}, I want to run automation on our collab post. Please approve my request on InstantDM:`;
        } else {
            defaultMsg = `Hey @${igDetail?.username}, I'm using InstantDM to automate our collab post. Please join here so I can set it up:`;
        }
        setInviteMessage(defaultMsg);

        if (!inviteLink) {
            await generateInviteLink();
        }
    }





    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const post_type = urlParams.get('post_type') || "posts";
    const platform_type = urlParams.get('platform_type') || "insta";
    const scheduled_post = urlParams.get('scheduled_post');



    // console.log("post_type-=-=-POST TYPE=-=-", post_type)

    const flow_editor = urlParams.get('flow_editor') || false;

    const [shopifyLinked, setShopifyLinked] = useState(false)

    const [showPublishModal, setShowPublishModal] = useState(true);
    const [publishStep, setPublishStep] = useState(0);

    // Save Logic
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [newAuthName, setNewAuthName] = useState("");

    // Prompt Function
    // Prompt Function deleted


    const confirmSaveAuth = async () => {
        if (!newAuthName.trim()) {
            message.error("Please provide a name");
            return;
        }
        let user_detail = JSON.parse(localStorage.getItem("userData"));
        if (!user_detail?.user_id) {
            message.error("User not found");
            return;
        }

        try {
            // We save data.auto_reply configuration
            await addDoc(collection(fireDB, "saved_automations"), {
                user_id: user_detail.user_id,
                name: newAuthName,
                config: data.auto_reply,
                createdAt: serverTimestamp()
            });
            message.success("Automation configuration saved!");
            window.location.reload();
        } catch (err) {
            console.error(err);
            message.error("Failed to save automation");
        }
    };

    // Browsing Logic
    const [savedAutomations, setSavedAutomations] = useState([]);
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const [authSearch, setAuthSearch] = useState("");
    const [editingAuth, setEditingAuth] = useState(null);
    const [isEditAuthModalOpen, setIsEditAuthModalOpen] = useState(false);

    const fetchSavedAutomations = async () => {
        let user_detail = JSON.parse(localStorage.getItem("userData"));
        if (!user_detail?.user_id) return;
        try {
            const q = query(collection(fireDB, "saved_automations"), where("user_id", "==", user_detail.user_id));
            const querySnapshot = await getDocs(q);
            const auths = [];
            querySnapshot.forEach((doc) => {
                auths.push({ id: doc.id, ...doc.data() });
            });
            auths.sort((a, b) => (b.createdAt?.toMillis() || 0) - (a.createdAt?.toMillis() || 0));
            setSavedAutomations(auths);
        } catch (err) {
            console.error("Error fetching automations:", err);
            message.error("Failed to load saved automations");
        }
    };

    const openAuthList = () => {
        fetchSavedAutomations();
        setIsAuthModalOpen(true);
    };

    const handleApplyAutomation = (config) => {
        setData({ ...data, auto_reply: { ...config } });
        setIsAuthModalOpen(false);
        message.success("Automation configuration applied!");
    };

    const handleDeleteAutomation = async (id) => {
        try {
            await deleteDoc(doc(fireDB, "saved_automations", id));
            message.success("Deleted");
            setSavedAutomations(prev => prev.filter(a => a.id !== id));
        } catch (err) {
            console.error(err);
            message.error("Failed to delete");
        }
    };

    const startEditAuth = (auth) => {
        setEditingAuth(auth);
        setIsEditAuthModalOpen(true);
    };

    const saveEditedAuth = async () => {
        if (!editingAuth || !editingAuth.name?.trim()) {
            message.error("Name is required");
            return;
        }
        try {
            await updateDoc(doc(fireDB, "saved_automations", editingAuth.id), {
                name: editingAuth.name,
                updatedAt: serverTimestamp()
            });
            message.success("Updated");
            setIsEditAuthModalOpen(false);
            setSavedAutomations(prev => prev.map(a => a.id === editingAuth.id ? { ...a, name: editingAuth.name } : a));
            setEditingAuth(null);
        } catch (err) {
            console.error(err);
            message.error("Failed to update");
        }
    };

    const filteredAuths = savedAutomations.filter(a => a.name?.toLowerCase().includes(authSearch.toLowerCase()));


    useEffect(() => {
        if (!callPostAPi || callPostAPi == undefined || callPostAPi == false) {
            return
        }
        // messageApi.open({
        //     type: 'loading',
        //     content: 'Please wait updating',
        //     duration: 0,
        // });
        setPublishStep(0)
        setShowPublishModal(true)
        let payload = { ...data, fb_post_id: fbDetail?.id }



        payload["auto_reply"]["enable"] = disableSection ? false : true
        if (shopifyLinked == true) {
            payload["shopify_linked"] = true
        }
        else {
            payload["shopify_linked"] = false
        }

        const isGlobal = new URLSearchParams(window.location.search).get("is_global") === "true";
        if (isGlobal) {
            payload["global_automation"] = true;
        }

        // Add post_type for stories
        if (post_type === "stories") {
            payload["post_type"] = "story";
        }

        // Add fb_page and is_fb parameters for Facebook posts
        if (platform_type === "fb") {
            payload["fb_page"] = true;
            payload["is_fb"] = true;
        }

        let apiURL = post_type == "next-post" ? `next-post` : `automate-post`
        localStorage.setItem("previous_config", JSON.stringify(payload))
        console.log("Shopify linked0=-=-=--", payload)
        setPublishStep(1)


        if (igDetail?.children) {
            callAPI({ url: "/coursal-link-post", method: "POST", body: { posts: igDetail?.children?.data, post_id: params.id }, loadingState: () => { }, dataState: () => { } })

        }



        if (fbDetail?.id) {
            let fb_payload = { ...data, post_id: fbDetail?.id }
            if (post_type === "stories") {
                fb_payload["post_type"] = "story";
            }
            if (platform_type === "fb") {
                fb_payload["fb_page"] = true;
                fb_payload["is_fb"] = true;
            }
            callAPI({ url: apiURL, method: "POST", body: fb_payload, loadingState: () => { }, dataState: () => { } })
        }
        callAPI({ url: apiURL, method: "POST", body: payload, loadingState: setLoading, dataState: setDataPostedState })


        setCallPostApi(false)


    }, [callPostAPi])

    useEffect(() => {
        if (dataPostedState == undefined) {
            return
        }

        messageApi.destroy()
        if (dataPostedState.code != 200) {
            message.error("Something went wrong please try again later.")
            // Error
        }
        else {
            // Success and close the drwaer
            setShowDrawer(false)
            setDrawerType('')
            setPublishStep(2)

            if (disableSection) {
                setPublishStep(3)

                message.success("Automation Updated")
                message.loading("Refreshing Page")
                // setTimeout(() => {
                //     window.location.reload();
                //   }, 2000);
            }
            else {
                // message.success("Automation is live")
                // message.loading("Refreshing Page")
                // setTimeout(() => {
                //     window.location.reload();
                //   }, 2000);
                setShowSuccessModal(true);
            }
            setDisableSection(false)
        }

    }, [dataPostedState])



    function ComingSoon() {
        return (<div className="cs" style={{ width: '100%', height: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
            <LinuxOutlined style={{ fontSize: '40px' }} />
            <p style={{ fontSize: '20px' }}>coming soon</p></div>)
    }

    let drawerTypeObj = {
        reply: {
            title: post_type == "stories" ? "Auto Reply to Story" : "Auto Reply to Comments",
            comp: <AutoReply state={{ ...data }} setData={setData} isStory={post_type == "stories"} isNextPostReply={post_type == "next-post"} setShowplan={setShowPlan} showPlan={showPlan} igData={igDetail} isGlobal={params.id.startsWith("global-") || new URLSearchParams(window.location.search).get("is_global") === "true"} openAuthList={openAuthList} />
        },
        hide: {
            title: "Auto Hide Comments",
            comp: <ComingSoon />
            // comp: <AutoHide state= {{...data}} setData = {setData} />
        },
        delete: {
            title: "Auto Delete Comments",
            comp: <ComingSoon />
            // comp: <AutoDelete state= {{...data}} setData = {setData} />
        },
        shopify: {
            title: "Shopify Automation",
            // comp:  <div>
            //     <p>1. Select Product</p>
            //     <p>2. Select Trigger word</p>
            //     <p>3. Build the flow Automatically use varients follow ups, collect name, phone number / email , out of stock, after out of stock or after purchase send similar products</p>
            //     <p>3.5 sometimes users dont want to have flow, just send the link of product open to shopify</p>
            //     <p>4. Option to Edit the flow if requried</p>
            //     <p>5. Publish</p>
            //     </div>
            comp: <ShopifyAutomate state={{ ...data }} setData={setData} isStory={post_type == "stories"} isNextPostReply={post_type == "next-post"} setShowplan={setShowPlan} showPlan={showPlan} HandleSPPublish={HandleSPPublish} igData={igDetail} />
        }
    }

    useEffect(() => {

        if (DrawerType == "reply") {

        }
        if (DrawerType == "hide") {

        }
        if (DrawerType == "delete") {

        }

    }, [DrawerType])

    useEffect(() => {

        if (dashboardAPIData == undefined) {
            return
        }
        // console.log("==========", dashboardAPIData)
        if (dashboardAPIData?.data != undefined) {
            setDashboardAPIData({ ...dashboardAPIData?.data })
        }
        // console.log("===========dahboard api data" , dashboardAPIData)
    }, [dashboardAPIData])
    const renderCollaborators = () => {
        let user_detail = {};
        try {
            user_detail = JSON.parse(localStorage.getItem("userData")) || {};
        } catch (e) { }

        return (
            <div style={{ padding: "20px 0" }}>
                <Card title="Collaboration Status" bordered={false} style={{ borderRadius: 12, boxShadow: 'none' }}>
                    {collaborators.length === 0 ? (
                        <Empty description="No collaborators or requests found" />
                    ) : (
                        <List
                            itemLayout="horizontal"
                            dataSource={collaborators}
                            renderItem={(item) => {
                                const isMyInvite = item.sender?.uid === user_detail?.user_id; // I sent this
                                const targetName = isMyInvite ? item.owner_username : item.sender?.username;
                                const actionText = isMyInvite ? `Invited @${targetName}` : `Invited by @${targetName}`;
                                const isPostOwner = item.accepted_by_uid === user_detail?.user_id || item.owner_id === user_detail?.user_id;

                                let statusColor = 'orange'; // pending
                                if (item.status === 'accepted') statusColor = 'green';
                                if (item.status === 'declined') statusColor = 'red';

                                return (
                                    <List.Item
                                        actions={[
                                            (isPostOwner && item.status === 'accepted') && (
                                                <Button
                                                    key="edit"
                                                    type="link"
                                                    icon={<EditOutlined />}
                                                    onClick={() => {
                                                        setEditingCollaborator(item);
                                                        setEditPermissions(item.permissions ? { ...item.permissions, view_contacts: true } : {
                                                            view_automation: false,
                                                            edit_automation: false,
                                                            view_contacts: true
                                                        });
                                                        setEditPermissionsModalOpen(true);
                                                    }}
                                                >
                                                    Edit Access
                                                </Button>
                                            )
                                        ]}
                                    >
                                        <List.Item.Meta
                                            avatar={<Avatar src={isMyInvite ? null : item.sender?.picture} icon={<UserOutlined />} size={48} >{isMyInvite ? targetName?.[0]?.toUpperCase() : null}</Avatar>}
                                            title={<div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                <b>{actionText}</b>
                                                <Tag color={statusColor} style={{ textTransform: 'capitalize' }}>{item.status}</Tag>
                                            </div>}
                                            description={
                                                <div style={{ marginTop: 8 }}>
                                                    {item.status === 'accepted' && (
                                                        <Space wrap>
                                                            {item.permissions?.view_automation && <Tag color="blue">View Config</Tag>}
                                                            {item.permissions?.edit_automation && <Tag color="geekblue">Edit Config</Tag>}
                                                            {item.permissions?.view_contacts && <Tag color="purple">View Contacts</Tag>}
                                                        </Space>
                                                    )}
                                                    <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                                                        {item.created_at ? new Date(item.created_at.seconds * 1000).toLocaleDateString() : 'N/A'}
                                                    </div>
                                                </div>
                                            }
                                        />
                                    </List.Item>
                                );
                            }}
                        />
                    )}
                </Card>
            </div>
        )
    };

    useEffect(() => {

        if (postComments == undefined) {
            return
        }
        if (postComments?.data != undefined) {
            setCommentPagination(postComments?.data?.pagination?.comment_id)
            setPostCommentsList([...postCommentsList, ...postComments?.data?.items])

        }
    }, [postComments])

    useEffect(() => {
        if (commentPaginationPageChange == 0) {
            return
        }
        let commentsURL = `ig-post-comments?post_id=${params.id}&last_comment_id=${commentPagination}&only_error=true`
        callAPI({ url: commentsURL, method: "GET", loadingState: setCommentsLoading, dataState: setPostComments })

    }, [commentPaginationPageChange])


    useEffect(() => {
        if (data == undefined) {
            return
        }

        if (data.data != undefined) {
            let tempData = data.data
            tempData.auto_reply.buttons = tempData.auto_reply.buttons || [{ "title": "click to edit", "url": "", "type": "web_url" }]
            setIGDetail({ ...location?.state?.post, ...data?.ig_post_data, owner_id: data?.owner_id })
            setFBDetail(data?.fb_post_data)

            setData({ ...data.data })

            setInitalState({ ...data.data })
        }


    }, [data])
    // 
    // console.log("post_type-=-=-=-=-", urlParams.get('post_type') , loading, data)
    useEffect(() => {

        // console.log("post_type-=-=-=-=-", urlParams.get('post_type') , loading, data)
        if (loading == true && data != undefined) {
            return
        }
        let tem_post_type = urlParams.get('post_type') || "posts";
        let apiURL = tem_post_type == "next-post" ? `next-post?post_id=${params.id}` : `automate-post?post_id=${params.id}`
        callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })

        const isGlobal = urlParams.get("is_global") === "true";

        if (isGlobal) {
            // If it's a global automation (even with a unique ID), we might want to fetch existing global config 
            // OR just start fresh/fetch based on ID if it exists. 
            // For now, let's assume if it's a new unique ID, it fetches nothing (empty) or whatever the backend returns for that ID.
            // But we MUST skip the dashboard/comments calls which are for specific posts.
            setDrawerType('')
            return;
        }

        if (params.id.startsWith("global-")) {
            let apiURL = `automate-post?post_id=${params.id}`
            callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })
            setDrawerType('')
            return;
        }



        if (tem_post_type != "next-post") {
            let apiURLDashboard = `post-dashboard?post_id=${params.id}`
            callAPI({ url: apiURLDashboard, method: "GET", loadingState: setLoading, dataState: setDashboardAPIData })

            let commentsURL = `ig-post-comments?post_id=${params.id}`
            callAPI({ url: commentsURL, method: "GET", loadingState: setCommentsLoading, dataState: setPostComments })

        }

        if (location.state?.post) {
            setIGDetail(location.state.post)
        }
        setDrawerType('')
    }, [])

    const showConfirm = (action_name) => {
        confirm({
            title: `Are you sure want to disable ${action_name}?`,
            icon: <ExclamationCircleFilled />,
            content: 'You can enable at anytime with current configuration.',
            okText: "Disable",
            cancelText: 'Cancel',
            onOk() {

                setDisableSection(true)
                setCallPostApi(true)
            },
            onCancel() {

            },
        });
    };


    const [fbPosts, setFBPosts] = useState({})
    const [loadFBPosts, setLoadFBPosts] = useState(0)
    const [showFbLinkModal, setShowFbLinkModal] = useState(false)


    useEffect(() => {
        if (loadFBPosts == 0) return;

        function addQueryParam(url, key, value) {
            return url + (url.includes("?") ? "&" : "?") + `${key}=${value}`;
        }

        let apiURL = "ig-posts"
        apiURL = addQueryParam(apiURL, "fb_page", true);
        if (fbPosts?.posts_lists?.paging?.cursors?.after) {
            apiURL = addQueryParam(apiURL, "after", fbPosts.posts_lists.paging.cursors.after);
        }
        callAPI({
            url: apiURL,

            method: "GET",

            loadingState: setLoading,

            dataState: (data_) => {

                const incoming = data_?.posts_lists?.data || [];
                const existing = fbPosts?.posts_lists?.data || [];
                let combined = [...incoming];
                combined = [...existing, ...incoming];
                const sorted = combined.sort((a, b) => {
                    const timeA = new Date(a.timestamp).getTime();
                    const timeB = new Date(b.timestamp).getTime();
                    return timeB - timeA;
                });
                const mergedData = {
                    ...data_,
                    posts_lists: {
                        ...data_.posts_lists,
                        data: sorted
                    }
                };
                setFBPosts(mergedData);
            }
        });

    }, [loadFBPosts]);



    function HandlePublish() {

        setShopifyLinked(false)


        let error = 0

        if (data["auto_reply"]["collect_money"] == true) {

            if (data["auto_reply"]["payment_details"] == undefined) {
                message.error("Product Details Missing")
                error += 1
            }

            if (data["auto_reply"]["payment_details"]["product_title"] == undefined || data["auto_reply"]["payment_details"]["product_title"].length < 1) {
                message.error("Product Title Missing")
                error += 1
            }
            if (data["auto_reply"]["payment_details"]["product_description"] == undefined || data["auto_reply"]["payment_details"]["product_description"].length < 1) {
                message.error("Product Title Missing")
                error += 1
            }
            if (data["auto_reply"]["payment_details"]["r_price"] == undefined || data["auto_reply"]["payment_details"]["r_price"] < 1) {
                message.error("Product Price should be more than or equal to 1")
                error += 1
            }
        }


        if (data["auto_reply"]["automate_all"] != "true" && data["auto_reply"]["triger_words"].length < 1) {

            message.error("Missing Trigger words")
            error += 1
        }


        if (data["auto_reply"]["enable_dm_reply"] != false && data["auto_reply"]["dm_reply_type"] != "sequence" && data["auto_reply"]["automate_all"] != "true") {

            if ((data["auto_reply"]["dm_template_type"] != "button" && data["auto_reply"]["dm_template_type"] != "products") && (data["auto_reply"]["dms"] != undefined && data["auto_reply"]["dms"][0].length < 1)) {
                message.error("Missing DM text")
                error += 1
            }

        }

        if (data["auto_reply"]["enable_comment_reply"] != false && data["auto_reply"]["reply_comments"].length < 1) {

            if (post_type != "stories") {
                message.error("Missing Reply comments words")
                error += 1
            }
        }


        if (error < 1) {

            // console.log("data", data)

            if (data["auto_reply"]?.["welcome_message"]?.["enabled"] != true && data?.auto_reply?.followers_only != true) {
                setShowAccountWaring(true)
                return
            }
            setCallPostApi(true)

        }
    }

    function HandleSPPublish() {

        console.log("-=-=-=-=-=data", data)
        setShopifyLinked(true)
        // return
        let error = 0
        if (data["auto_reply"]["automate_all"] != "true" && data["auto_reply"]["triger_words"].length < 1) {

            message.error("Missing Trigger words")
            error += 1
        }
        if (data["auto_reply"]["reply_comments"].length < 1) {

            if (post_type != "stories") {
                message.error("Missing Reply comments words")
                error += 1
            }
        }

        if (error < 1) {
            if (data["auto_reply"]?.["welcome_message"]?.["enabled"] != true && data?.auto_reply?.followers_only != true) {
                // setShowAccountWaring(true)
                // return
            }
            setCallPostApi(true)

        }
    }

    useEffect(() => {



    }, [showPlan])

    const renderAutomationSetup = () => {

        if (commentsLoading || data == undefined || data.data != undefined) {
            return <div style={{ width: '100%', height: '100hh', display: 'flex', alignContent: 'center', justifyContent: 'center' }}> <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />Please Wait...</div>
        }
        return (<>

            {
                post_type == "next-post" && <Alert style={{ maxWidth: "600px" }} closable showIcon type="info" message="FB and IG will be automated." description="This coufiguration will be automatically applied to your next IG and FB Page post." />
            }

            {(post_type != "next-post" && post_type != "stories" && !scheduled_post && !params.id.startsWith("global-") && new URLSearchParams(window.location.search).get("is_global") !== "true") &&
                <PostPreview
                    igDetail={igDetail}
                    fbDetail={fbDetail}
                    onLinkFacebook={() => { setShowFbLinkModal(true); setLoadFBPosts(loadFBPosts + 1) }}
                    hideFacebook={post_type === "collabs"}
                />}

            {
                post_type == "collabs" &&
                <Alert
                    message="Collab Post"
                    description={
                        <div>
                            This is a Collab post {igDetail?.username && <span>from <b>@{igDetail.username}</b></span>}.
                        </div>
                    }
                    type="info"
                    showIcon
                    style={{ maxWidth: 700, marginTop: 20, marginBottom: 20 }}
                />
            }

            {
                (igDetail?.error && post_type == "collabs") &&
                <Alert
                    message="Permission Error"
                    description={
                        <div>
                            <p>Looks like <b>@{igDetail?.username || "creator"}</b> has not given access to you.</p>
                            {
                                igDetail?.owner?.username !== "instantdm" &&
                                <Button
                                    type="primary"
                                    loading={checkingAccess}
                                    onClick={checkCreatorAccess}
                                    style={{ marginTop: 8 }}
                                // disabled={creatorStatus === 'on_idm'}
                                >
                                    {creatorStatus === 'on_idm' ? "Request Access" : creatorStatus === 'not_on_idm' ? "Invite to InstantDM" : "Request Access"}
                                </Button>
                            }
                        </div>
                    }
                    type="error"
                    showIcon
                    style={{ maxWidth: 700, marginTop: 20, marginBottom: 20 }}
                />
            }

            {(params.id.startsWith("global-") || new URLSearchParams(window.location.search).get("is_global") === "true") &&
                <Alert
                    message={`Global ${post_type === 'posts' ? 'Post' : 'Story'} Automation`}
                    description={`This configuration will be applied to all your ${post_type === 'posts' ? 'posts' : 'stories'}.`}
                    type="info"
                    showIcon
                    style={{ maxWidth: 700, marginTop: 20, marginBottom: 20 }}
                />
            }


            {(post_type === "collabs" && (!currentUserPermissions.view_automation || !igDetail?.owner_id == user_detail?.user_id)) ? <Result status="403" title="Access Restricted" subTitle="You do not have permission to view this automation configuration." /> :

                <>
                    <h1> {post_type == "stories" ? "Story Automation" : post_type == "next-post" ? "Configure your Next Post automation" : "Post Automations"}</h1>


                    <div className="automated-flex" style={{ paddingBottom: "20px" }}>
                        <div className="automate-options" onClick={(event) => {
                            // if (!currentUserPermissions.view_automation) return;

                            if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                                setShowDrawer(true);
                                setDrawerType('reply');
                            }
                        }} >
                            <Switch disabled={!currentUserPermissions.edit_automation} value={data.auto_reply.enable && !data.shopify_linked} className="switch" onClick={(value) => {

                                if (value == false) {
                                    showConfirm('Auto Reply')
                                }
                                else {
                                    setShowDrawer(true); setDrawerType('reply')
                                }

                            }} />
                            <LinkOutlined className="icon reply" />
                            <div>
                                <h4>Send Link or Images</h4>
                                {post_type == "stories" ?
                                    <p>When your audience replies to your story for "Link" or any other specified word. Automatically send them resources via direct message(DM).</p>
                                    :
                                    <p>When your audience comments "Link" or any other specified word. Automatically send them resources via comment and direct message(DM).</p>
                                }
                            </div>
                        </div>

                        {/* <div className="automate-options" onClick={(event) => {

                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                        setShowDrawer(true);
                        setDrawerType('reply');
                    }
                }} >
                    <Switch value={data.auto_reply.enable} className="switch" onClick={(value) => {

                        if (value == false) {
                            showConfirm('Auto Reply')
                        }
                        else {
                            setShowDrawer(true); setDrawerType('reply')
                        }

                    }} />
                    <MailOutlined className="icon mail" />
                    <h4>Collect Email / Whatsapp</h4>
                    {post_type == "stories" ?
                        <p>When your audience replies to your story for "Link" or any other specified word. Automatically send them resources via direct message(DM).</p>
                        :
                        <p>When your audience comments "Link" or any other specified word. Automatically send them resources via comment and direct message(DM).</p>
                    }
                </div> */}

                        {!(post_type === "collabs" && !currentUserPermissions.is_owner) && <div className="automate-options" onClick={(event) => {
                            // if (!currentUserPermissions.view_automation) return;

                            if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {

                                if (!localStorage.getItem("shopify_store")) {
                                    window.location.href = "/shopify";

                                    // showConnectShopfyModel
                                    return
                                }

                                setShowDrawer(true);
                                setDrawerType('shopify');
                            }
                        }} >
                            <Switch disabled={!currentUserPermissions.edit_automation} value={data.auto_reply.enable && data.shopify_linked} className="switch" onClick={(value) => {

                                if (value == false) {
                                    showConfirm('Auto Reply')
                                }
                                else {
                                    if (!localStorage.getItem("shopify_store")) {
                                        // showConnectShopfyModel
                                        window.location.href = "/shopify";
                                        return
                                    }
                                    setShowDrawer(true); setDrawerType('shopify')
                                }

                            }} />
                            <ShopOutlined className="icon shop" />
                            <h4>Sell Shopify Product <Tag color="purple">Beta</Tag></h4>

                            <p>
                                Instantly share your Shopify products inside Instagram posts, reels, or stories.
                                Make it easy for followers to view and buy without leaving the app — boosting engagement
                                and driving higher conversions.
                            </p>

                        </div>}

                        {flow_editor != "true" && !(post_type === "collabs" && !currentUserPermissions.is_owner) && <div className="automate-options"
                            onClick={(event) => {
                                window.location.href = "/?tab=3"
                            }} >
                            <Switch value={flow_editor == "true"} className="switch" />
                            <ApartmentOutlined className="icon flow-node" />
                            <h4>Collect Email / Lead Gen</h4>

                            <p>
                                You know you can collect email, phone number, ratings using our advanced flow editor.
                            </p>

                        </div>}

                        {/* <div className="automate-options" onClick={(event) => {

                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                        setShowDrawer(true);
                        setDrawerType('reply');
                    }
                }} >
                    <Switch value={data.auto_reply.enable} className="switch" onClick={(value) => {

                        if (value == false) {
                            showConfirm('Auto Reply')
                        }
                        else {
                            setShowDrawer(true); setDrawerType('reply')
                        }

                    }} />
                    <BranchesOutlined className="icon flow" />
                    <h4>Build Custom Flow</h4>
                    {post_type == "stories" ?
                        <p>When your audience replies to your story for "Link" or any other specified word. Automatically send them resources via direct message(DM).</p>
                        :
                        <p>When your audience comments "Link" or any other specified word. Automatically send them resources via comment and direct message(DM).</p>
                    }
                </div> */}
                    </div>
                </>

            }




        </>)
    }

    function ListPostComments() {
        function unixToLocalDateTime(unixTimestamp) {
            const date = new Date(unixTimestamp * 1000); // convert seconds to milliseconds
            return date.toLocaleString([], { hour12: true, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        }
        function convertToLocalDateTime(dateString) {

            try {

                const date = new Date(dateString);

                // return date.toLocaleTimeString();
                const utcTime = new Date(dateString);

                const localTime = new Date(utcTime + 'Z').toLocaleString([], { hour12: true, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });

                return localTime
            }
            catch {
                return "-"
            }

        }


        // Utility function to safely access deeply nested properties
        const safeAccess = (fn, fallback = "N/A") => {
            try {
                return fn();
            } catch {
                return fallback;
            }
        };

        // Utility function to get comment text safely
        const getCommentText = (record) => {
            if (record.story_reply) {
                return <Tag color="geekblue">DM Reply</Tag>
            }
            return safeAccess(
                () => record.event_dumb.entry[0].changes[0].value.text,
                record.event_dumb.text || "NA"
            );
        };

        // Columns definition with safe handling
        const hasCity = postCommentsList.some(record => !!record.city);
        const columns = [
            {
                title: 'Insta ID',
                render: (_, record) =>

                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].sender.id,
                                record.event_dumb?.from?.username
                            )}
                        </p>
                    ) : (
                        <p >
                            {safeAccess(
                                () => record.event_core.from.username ? <a href={`https://instagram.com/${record.event_core.from.username}`} target="_blank">  {record.event_core.from.username}</a> : <p> {record.event_core.from.name}</p>

                            )}
                        </p>
                    ),
                key: 'id',
                maxWidth: '100px',
            },
            {

                title: 'Status',
                render: (_, record) =>
                (<>


                    {record.order_status === "completed" && (
                        <a
                            href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Tag color="green" icon={<DollarCircleOutlined />}>
                                Sale {record?.order_data?.order_data?.name}
                            </Tag>
                        </a>
                    )}

                    {record.sp_status && <> <Tag color="purple" icon={<ShopOutlined />}>{record?.sp_status}</Tag></>}

                    {record.ig_rate_limit && <><Tooltip title="Instagram limit reached"> <Tag color="red" icon={<WarningOutlined />}> Instagram limit reached</Tag></Tooltip> {!["428337", "428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade your plan for auto process.</Button>} </>}
                    {record.paid && <> <Tag color="geekblue" icon={<MoneyCollectTwoTone />}>Paid</Tag></>}
                    {(!record.ig_rate_limit && record.hourly_limit_reached) && <><Tooltip title={!["428337", "428338"].includes(localStorage.getItem("planid")) ? "Hourly limit reached. Upgrade your plan for higher rate limits." : "This comment reached hourly limit, before switching plan."}> <Tag color="red" icon={<WarningOutlined />}>Rate limit reached</Tag></Tooltip> {!["428337", "428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade your plan for higher rate limits.</Button>} </>}
                    {record.waiting && <> <Tooltip title="Waiting in Queue"> <Tag color="geekblue" icon={<ClockCircleOutlined />}>Scheduled</Tag> </Tooltip> </>}
                    {(!record.sp_status && !record.hourly_limit_reached && !record.waiting) && record.dm_responded == "true" && <> <Tooltip title="DM Sent"> <Tag color="green" icon={<SendOutlined />}>Sent</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded != "true" && <> <Tooltip title="DM Not Sent"> <Tag color="red" icon =  {<SendOutlined/>}>Failed</Tag> </Tooltip> </>} */}
                    {(!record.hourly_limit_reached && !record.waiting && record.cm_responded == "true" && record.story_reply != true) && <> <Tooltip title="Comment replied"> <Tag color="green" icon={<CommentOutlined />}>Replied</Tag> </Tooltip> </>}
                    {record.link_opened && <> <Tag color="purple" icon={<BsCursor />}>Link Opened</Tag></>}
                    {/* {(!record.hourly_limit_reached && !record.waiting && !record.waiting && record.cm_responded == "false" && record.story_reply == false) && <> <Tooltip title="Comment not replied"> <Tag color="red" icon = {<CommentOutlined />}>Failed</Tag> </Tooltip> </>} */}
                </>),
                // record.responded ? (
                //     <Tag icon={<CheckCircleOutlined />} color="success">
                //         success
                //     </Tag>
                // ) : (
                //     <Tooltip title="Error" color={'red'} key={'red'}>
                //         <Tag icon={<CloseCircleOutlined />} color="error">
                //             error
                //         </Tag>
                //     </Tooltip>
                // ),
                key: 'responded',
            },
            ...(hasCity ? [

                {
                    title: <p>City</p>,
                    render: (_, record) =>
                    (<>
                        {record.city && <p>{record.city}</p>}

                    </>),

                    key: 'city'
                },
            ] : []),
            {
                title: 'Comment',
                render: (_, record) =>
                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].message.text,
                                record.event_dumb.from?.username
                            )}
                        </p>
                    ) : (
                        <p>{getCommentText(record)}</p>
                    ),
                key: 'comment',
            },
            {
                title: 'Responded Time',
                render: (_, record) => record.waiting ? `Sechduled at ${convertToLocalDateTime(record.responded_at)}` : convertToLocalDateTime(record.responded_at),
                key: 'rt',
            },
        ];

        // Mobile columns with safe handling
        const mobileColumns = [
            {
                title: 'Insta ID',
                render: (_, record) =>

                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].sender.id,
                                record.event_dumb?.from?.username
                            )}
                        </p>
                    ) : (
                        <p >
                            {safeAccess(
                                () => <a href={`https://instagram.com/${record.event_core.from.username}`} target="_blank">{record.event_core.from.username}</a>

                            )}
                        </p>
                    ),
                key: 'id',
                maxWidth: '100px',
            },
            {
                title: 'Status',
                render: (_, record) =>

                (<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {record.order_status === "completed" && (
                        <a
                            href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Tag color="green" icon={<DollarCircleOutlined />}>
                                Sale {record?.order_data?.order_data?.name}
                            </Tag>
                        </a>
                    )}

                    {record.sp_status && <> <Tag color="purple" icon={<ShopOutlined />}>{record?.sp_status}</Tag></>}

                    {record.ig_rate_limit && <><Tooltip title="Instagram limit reached"> <Tag color="red" icon={<WarningOutlined />}> Instagram limit reached</Tag></Tooltip> {!["428337", "428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade your plan for auto process.</Button>} </>}
                    {(!record.ig_rate_limit && record.hourly_limit_reached) && <><Tooltip title={!["428337", "428338"].includes(localStorage.getItem("planid")) ? "Hourly limit reached. Upgrade your plan for higher rate limits." : "This comment reached hourly limit, before switching plan."}> <Tag color="red" icon={<WarningOutlined />}>Rate limit reached</Tag></Tooltip> {["428337", "428338"].includes(localStorage.getItem("planid")) && <Button style={{ marginTop: '20px' }} color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade for higher rate limit</Button>} </>}
                    {record.paid && <> <Tag color="geekblue" icon={<MoneyCollectTwoTone />}>Paid</Tag></>}
                    {record.waiting && <> <Tooltip title="Waiting in Queue"> <Tag color="geekblue" icon={<ClockCircleOutlined />}>Scheduled</Tag> </Tooltip> </>}
                    {(!record.sp_status && !record.hourly_limit_reached && !record.waiting) && record.dm_responded == "true" && <> <Tooltip title="DM Sent"> <Tag color="green" icon={<SendOutlined />}>Sent</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded != "true" && <> <Tooltip title="DM Not Sent"> <Tag color="red" icon =  {<SendOutlined/>}>Failed</Tag> </Tooltip> </>} */}
                    {(!record.hourly_limit_reached && !record.waiting && record.cm_responded == "true" && record.story_reply != true) && <> <Tooltip title="Comment replied"> <Tag color="green" icon={<CommentOutlined />}>Replied</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting && !record.waiting && record.cm_responded == "false" && record.story_reply == false) && <> <Tooltip title="Comment not replied"> <Tag color="red" icon = {<CommentOutlined />}>Failed</Tag> </Tooltip> </>} */}
                    {record.link_opened && <> <Tag color="purple" icon={<BsCursor />}>Link Opened</Tag></>}
                    {record.city && <> <Tag color="orange" icon={<GlobalOutlined />}>{record.city}</Tag></>}
                </div>),
                key: 'responded',
            },

        ];



        if (commentsLoading || postCommentsList.length < 1) {
            return <div style={{ width: '100%', height: '100hh', display: 'flex', alignContent: 'center', justifyContent: 'center' }}> <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />Please Wait...</div>
        }

        return (
            <div>

                <Table dataSource={postCommentsList}
                    tableLayout="auto"
                    rowKey={(record) => record.comment_id}
                    columns={columns}
                    pagination={false}
                    expandable={{
                        expandRowByClick: false,
                        // defaultExpandAllRows:true,
                        expandedRowRender: (record) => (
                            <div>
                                {record?.order_data?.order_data?.id && <Button href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`} target="_blank">See Order {record?.order_data?.order_data?.name}</Button>}

                                <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px'
                                    }}
                                >
                                    #id: {record.comment_id} <br />
                                    {record.paid && <> <Tag color="geekblue" icon={<MoneyCollectTwoTone />}>Paid</Tag></>}
                                    # DM Sent : {record.waiting ? "Scheduled" : record.dm_responded} <br />
                                    # Link Opened Time : {convertToLocalDateTime(record.link_open_at) == "Invalid Date" ? "NA" : convertToLocalDateTime(record.link_open_at)}
                                </p>

                                <StatusTimeline timeline={record?.sp_status_timeline} />
                            </div>
                        ),
                        // rowExpandable: (record) => record.reason !== 'Not Expandable',
                    }}
                    className="desktop"
                />

                <Table dataSource={postCommentsList}
                    tableLayout="auto"
                    rowKey={(record) => record.comment_id}
                    columns={mobileColumns}
                    pagination={false}
                    expandable={{
                        expandRowByClick: true,
                        // defaultExpandAllRows:true,
                        expandedRowRender: (record) => (
                            <div>
                                {record?.order_data?.order_data?.id && <Button href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`} target="_blank">See Order {record?.order_data?.order_data?.name}</Button>}

                                <StatusTimeline timeline={record?.sp_status_timeline} />

                                {post_type != "stories" && <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px'
                                    }}
                                >

                                    Comment :{getCommentText(record)} <br /> <br />

                                    {record.waiting ? "Sechduled at" : "Responded at"} {convertToLocalDateTime(record.responded_at)} <br />
                                    #id: {record.comment_id} <br />
                                </p>
                                }
                                {post_type == "stories" && <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px',
                                        overflowX: 'hidden'
                                    }}
                                >

                                    Comment : {record.event_dumb.entry != undefined ? record.event_dumb["entry"][0].messaging[0]["message"]["text"] : record.event_dumb?.text} <br />
                                    Replied at : {convertToLocalDateTime(record.responded_at)} <br />
                                    #id: {record.comment_id.slice(0, 40)} <br />
                                    # Link Opened Time : {convertToLocalDateTime(record.link_open_at) == "Invalid Date" ? "NA" : convertToLocalDateTime(record.link_open_at)}
                                </p>
                                }
                            </div>
                        ),
                        // rowExpandable: (record) => record.reason !== 'Not Expandable',
                    }}
                    className="mobile"
                />
                <Button href="#" onClick={() => setCommentPaginationPageChange(commentPaginationPageChange + 1)} type="primary"
                    style={{ padding: '10px', width: '100px', marginTop: '20px', marginBottom: '20px' }}
                    disabled={postCommentsList.length >= dashboardAPIData?.total_comments}>Load More</Button>
            </div>
        )
    }


    return (
        <div className="page-layout">
            {contextHolder}
            {/* Invite Modal Moved Here */}
            <Modal
                title={creatorStatus === 'on_idm' ? "Request Access from Creator" : "Invite Creator to InstantDM"}
                open={showInviteModal}
                onCancel={() => setShowInviteModal(false)}
                footer={null}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                    {generatingLink ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                            <p style={{ marginTop: 10 }}>Generating unique invite link...</p>
                        </div>
                    ) : (
                        <>

                            {creatorStatus === 'on_idm' ? (
                                <Alert
                                    message={`Good news! @${igDetail?.username} is already on InstantDM.`}
                                    description="Share the link so they can give access to you."
                                    type="success"
                                    showIcon
                                    style={{ marginBottom: '10px' }}
                                />
                            ) : (
                                <p>Copy the message below and send it to <b>@{igDetail?.username}</b> to invite them!</p>
                            )}

                            <div style={{ marginBottom: '16px' }}>
                                <Input.TextArea
                                    value={inviteMessage}
                                    onChange={(e) => setInviteMessage(e.target.value)}
                                    autoSize={{ minRows: 2, maxRows: 6 }}
                                    style={{ marginBottom: '8px', background: '#f5f5f5' }}
                                />
                                <div style={{
                                    padding: '8px 12px',
                                    background: '#e6f7ff',
                                    border: '1px solid #91d5ff',
                                    borderRadius: '6px',
                                    color: '#1890ff',
                                    fontSize: '13px',
                                    wordBreak: 'break-all'
                                }}>
                                    {inviteLink || "Generating link..."}
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <Button
                                    type="primary"
                                    icon={<CopyOutlined />}
                                    onClick={() => {
                                        let linkToUse = inviteLink || "https://instantdm.com";
                                        let fullText = `${inviteMessage} ${linkToUse}`;
                                        navigator.clipboard.writeText(fullText);
                                        message.success("Message copied to clipboard!");
                                    }}
                                >
                                    Copy Message
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </Modal>
            <Sider setShowPlan={setShowPlan} showPlan={showPlan} />



            <div className="page-content">
                {flow_editor == "true" && <Alert
                    style={{ marginBottom: '10px', marginTop: '10px' }}
                    message="Configured via Flow Editor, but editable!"
                    description="This post was set up through the Flow Editor. You can edit it manually, but any modifications will replace the existing Flow Editor settings for this post alone."
                    type="warning"

                />
                }


                {
                    params.id == "global" && <Alert
                        style={{ marginBottom: '10px', marginTop: '10px' }}
                        message="Global Automation"
                        description="This is a global automation, it will apply to all posts and stories. But post specific automation will override this."
                        type="info" />
                }
                <Breadcrumb
                    style={{ marginTop: '20px' }}
                    separator=">"
                    items={[
                        {
                            title: <Link to={platform_type == "insta" ? "/" : "/fb"}>{post_type == "stories" ? "Stories" : post_type == "next-post" ? "Next post" : "Posts"}</Link>,

                        },
                        {
                            title: 'Automation',
                        },
                    ]}
                />

                {/* {post_type != "next-post" && dashboardAPIData?.total_comments != undefined && <Row style={{ marginTop: '20px' }} gutter={18}>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Total DM's" : "Total Comments"} value={dashboardAPIData?.total_comments || 'NA'} formatter={formatter} />
                    </Col>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Automated DM's" : "Automated Comments"} value={dashboardAPIData?.total_responded || 'NA'} formatter={formatter} />
                    </Col>
                    {dashboardAPIData?.shopify_sale > 0 && <Col span={6}>
                        <Statistic title={"Sales"} value={dashboardAPIData?.shopify_sale || 'NA'} formatter={formatter} />
                    </Col>}
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Waiting DM's" : "Waiting Comments"} value={dashboardAPIData?.total_waiting || 'NA'} formatter={formatter} />
                    </Col>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Skipped DM's" : "Skipped Comments"} value={dashboardAPIData?.limit_reached_count || 'NA'} formatter={formatter} />
                     </Form>
                </Modal> */}

                {/* Saved Automations List Modal */}
                <Modal
                    title="Saved Automations"
                    open={isAuthModalOpen}
                    onCancel={() => setIsAuthModalOpen(false)}
                    footer={null}
                    width={600}
                    zIndex={1002}
                >
                    <Input
                        prefix={<SearchOutlined />}
                        placeholder="Search automations..."
                        value={authSearch}
                        onChange={(e) => setAuthSearch(e.target.value)}
                        style={{ marginBottom: 16 }}
                    />

                    <List
                        dataSource={filteredAuths}
                        locale={{ emptyText: "No saved automations found" }}
                        itemLayout="horizontal"
                        pagination={{ pageSize: 5 }}
                        renderItem={(item) => (
                            <List.Item
                                actions={[
                                    <Button size="small" type="link" onClick={() => handleApplyAutomation(item.config)}>Apply</Button>,
                                    <Button size="small" type="text" icon={<EditOutlined />} onClick={() => startEditAuth(item)} />,
                                    <Popconfirm title="Delete?" onConfirm={() => handleDeleteAutomation(item.id)}>
                                        <Button size="small" type="text" danger icon={<DeleteOutlined />} />
                                    </Popconfirm>
                                ]}
                            >
                                <List.Item.Meta
                                    title={<b>{item.name}</b>}
                                    description={<span style={{ fontSize: 12, color: '#888' }}>Created: {item.createdAt?.toDate ? item.createdAt.toDate().toLocaleDateString() : 'Just now'}</span>}
                                />
                            </List.Item>
                        )}
                    />
                </Modal>

                {/* Edit Automation Modal */}
                <Modal
                    title="Edit Automation Name"
                    open={isEditAuthModalOpen}
                    onOk={saveEditedAuth}
                    onCancel={() => setIsEditAuthModalOpen(false)}
                    zIndex={1003}
                >
                    {editingAuth && (
                        <Form layout="vertical">
                            <Form.Item label="Name" required>
                                <Input
                                    value={editingAuth.name}
                                    onChange={(e) => setEditingAuth({ ...editingAuth, name: e.target.value })}
                                />
                            </Form.Item>
                        </Form>
                    )}
                </Modal>

                {/* } */}
                <Tabs
                    defaultActiveKey="1"
                    items={[{
                        key: 1,
                        label: `Automation Configuration `,
                        children: renderAutomationSetup(),
                        icon: '',
                    },
                    post_type != "next-post" && {
                        key: 2,
                        label: post_type == "stories" ? `All DM's` : `All Comments`,
                        children: <ListPostComments />,
                        icon: '',
                    }, {
                        key: 3,
                        label: `Collaborators`,
                        children: renderCollaborators(),
                        icon: <UsergroupAddOutlined />,
                    }
                        // {
                        //     key: 3,
                        //     label: `Replied Comments`,
                        //     children: `List of replied Comments`,
                        //     icon: '',
                        // },{
                        //     key: 4,
                        //     label: `Hidden Comments`,
                        //     children: `List of Hidden Comments`,
                        //     icon: '',
                        // },{
                        //     key: 5,
                        //     label: `Deleted Comments`,
                        //     children: `List of Deleted Comments`,
                        //     icon: '',
                        // },
                    ]}
                />
                <Drawer
                    title={drawerTypeObj[DrawerType]?.title}
                    placement="right"
                    open={showDrawer}
                    style={{ backgroundColor: '#EBF1FE' }}
                    // width={'600px'}
                    width={"100%"}
                    onClose={() => { setShowDrawer(false); setData(initalState) }}
                    extra={
                        <Space>
                            {DrawerType == "reply" && currentUserPermissions.edit_automation &&
                                <Space>
                                    <Button onClick={() => { setShowDrawer(false); setData(initalState) }}>Cancel</Button>
                                    <Button type="primary"
                                        onClick={() => HandlePublish()} loading={posting}>
                                        Publish
                                    </Button>
                                </Space>}
                            {DrawerType == "shopify" &&
                                <Button type="primary"
                                    href="https://yt.opnin.app/9c3c5"
                                    target="_blank"
                                    icon={<VideoCameraOutlined />}>
                                    Watch Video
                                </Button>
                            }
                        </Space>


                    }
                >

                    {drawerTypeObj[DrawerType]?.comp}

                </Drawer>
            </div>

            <Modal

                open={showAccountWaring}
                onCancel={() => setShowAccountWaring(false)}
                footer={[
                    <Button key="edit" onClick={() => { setShowAccountWaring(false) }}>
                        Edit Automation
                    </Button>,
                    <Button key="publish" type="primary" onClick={() => {
                        setShowAccountWaring(false);
                        setCallPostApi(true)

                    }}>
                        Send link directly
                    </Button>,
                ]}
                centered
            >
                <Alert
                    type="info"
                    showIcon
                    message="Recommended Setup for Better Engagement"
                    description={
                        <>
                            <h3>
                                Enable a <strong>welcome message</strong> or <strong>follow-for-link</strong> to improve results.
                            </h3>
                            <p> This helps build trust and boosts engagement before your links are shared.</p>
                            <Tooltip title="Users who enable welcome messages or require a follow before sending links tend to see better interaction rates and smoother message delivery.">

                                <p style={{ textDecoration: "underline" }}>What does this mean?</p>
                            </Tooltip>
                        </>
                    }
                />
            </Modal>


            <Modal
                title="Select FB Post"
                open={showFbLinkModal}
                onCancel={() => {
                    setShowFbLinkModal(false);
                    setLoadFBPosts(0);
                }}
                width={700}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => {
                            setShowFbLinkModal(false);
                            setLoadFBPosts(0);
                        }}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="select"
                        type="primary"
                        disabled={!selectedFBDetail}
                        onClick={() => {
                            setFBDetail(selectedFBDetail);
                            setShowFbLinkModal(false);
                            setLoadFBPosts(0);
                        }}
                    >
                        Select Post
                    </Button>,
                ]}
            >
                <div style={{ maxHeight: "420px", overflowY: "auto", padding: "8px 0" }}>
                    {fbPosts?.posts_lists?.data ? (
                        <Flex wrap gap={10} justify="flex-start" align="center">
                            {fbPosts.posts_lists.data.map((post, index) => {
                                const imgSrc =
                                    post.thumbnail_url || post.media_url || post.full_picture;
                                const isSelected = selectedFBDetail?.id === post.id;

                                return (
                                    <div
                                        key={post.id || index}
                                        onClick={() => setSelectedFBDetail(post)}
                                        style={{
                                            cursor: "pointer",
                                            border: isSelected
                                                ? "2px solid #1677ff"
                                                : "1px solid #e0e0e0",
                                            borderRadius: 10,
                                            overflow: "hidden",
                                            transition: "all 0.2s ease",
                                            boxShadow: isSelected
                                                ? "0 2px 8px rgba(22, 119, 255, 0.2)"
                                                : "0 1px 4px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        <img
                                            alt={post.caption}
                                            style={{
                                                width: 150,
                                                height: 150,
                                                objectFit: "cover",
                                                display: "block",
                                            }}
                                            className="thumbnail-img"
                                            src={imgSrc}
                                            crossOrigin="anonymous"
                                        />
                                    </div>
                                );
                            })}
                        </Flex>
                    ) : (
                        <div style={{ textAlign: "center", color: "#999", padding: "40px 0" }}>
                            No Facebook posts found
                        </div>
                    )}

                    {fbPosts?.posts_lists?.paging?.cursors?.after && (
                        <div style={{ textAlign: "center", marginTop: 20 }}>
                            <Button
                                type="default"
                                shape="round"
                                onClick={() =>
                                    setLoadFBPosts(fbPosts.posts_lists.paging.cursors.after)
                                }
                            >
                                Load More
                            </Button>
                        </div>
                    )}
                </div>
            </Modal>

            {/* Success & Save Modal */}
            <Modal
                title={null}
                open={showSuccessModal}
                footer={null}
                closable={false}
                maskClosable={false}
                centered
            >
                <div style={{ textAlign: "center", paddingBottom: "20px" }}>
                    <CheckCircleOutlined style={{ fontSize: "50px", color: "#52c41a", marginBottom: "15px" }} />
                    <h2 style={{ margin: 0 }}>Automated Successfully!</h2>
                    <p style={{ color: "#888", marginTop: "5px" }}>Your automation is live and running.</p>
                </div>

                <Card title="Save to Library" size="small" style={{ marginBottom: "20px", background: "#f9f9f9" }}>
                    <p style={{ marginBottom: "10px" }}>Save this configuration to your library for future use.</p>
                    <Form layout="vertical">
                        <Form.Item label="Configuration Name" style={{ marginBottom: 0 }}>
                            <Input
                                value={newAuthName}
                                onChange={(e) => setNewAuthName(e.target.value)}
                                placeholder="e.g., Summer Sale, Welcome Message..."
                            />
                        </Form.Item>
                    </Form>
                </Card>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <Button onClick={() => window.location.reload()}>
                        Close
                    </Button>
                    <Button type="primary" onClick={confirmSaveAuth}>
                        Save to Library
                    </Button>
                </div>
            </Modal>

            {/* Review Request Modal */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <SafetyCertificateOutlined style={{ color: 'green', fontSize: 20 }} />
                        <span>Review Collaboration Request</span>
                    </div>
                }
                open={reviewModalOpen}
                onCancel={() => setReviewModalOpen(false)}
                closable={false}
                maskClosable={false}
                footer={[
                    <Button key="decline" danger onClick={handleDeclineRequest}>
                        Decline
                    </Button>,
                    <Button key="accept" type="primary" loading={reviewProcessing} onClick={handleAcceptRequest}>
                        Accept Request
                    </Button>
                ]}
            >
                {reviewInviteData && (
                    <div>
                        <div style={{ textAlign: "center", marginBottom: 20 }}>
                            {reviewInviteData.sender?.picture && (
                                <img
                                    src={reviewInviteData.sender?.picture}
                                    style={{ width: 60, height: 60, borderRadius: "50%", marginBottom: 10 }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                    alt="sender"
                                />
                            )}
                            <h3>@{reviewInviteData.sender?.username}</h3>
                            <p>requests to manage automation for this post.</p>
                        </div>

                        <Alert
                            message="Select Access Level"
                            description="Choose what they can access. You can change this anytime."
                            type="info"
                            showIcon
                            style={{ marginBottom: 16 }}
                        />

                        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                            <Card size="small">
                                <Checkbox
                                    checked={reviewPermissions.view_automation}
                                    onChange={(e) => setReviewPermissions({ ...reviewPermissions, view_automation: e.target.checked })}
                                >
                                    <span style={{ fontWeight: 500 }}>View Automation Configuration</span>
                                    <p style={{ margin: 0, color: "#666", fontSize: 12 }}>Can see how automation is set up, such as links, welcome message and more.</p>
                                </Checkbox>
                            </Card>

                            <Card size="small">
                                <Checkbox
                                    checked={reviewPermissions.edit_automation}
                                    onChange={(e) => setReviewPermissions({ ...reviewPermissions, edit_automation: e.target.checked })}
                                >
                                    <span style={{ fontWeight: 500 }}>Edit Automation</span>
                                    <p style={{ margin: 0, color: "#666", fontSize: 12 }}>Can modify the automation messages such as links, welcome message and more.</p>
                                </Checkbox>
                            </Card>

                            <Card size="small">
                                <Checkbox
                                    disabled
                                    checked={reviewPermissions.view_contacts}
                                    onChange={(e) => setReviewPermissions({ ...reviewPermissions, view_contacts: e.target.checked })}
                                >
                                    <span style={{ fontWeight: 500 }}>View Comments (Public Data)</span>
                                    <p style={{ margin: 0, color: "#666", fontSize: 12 }}>Can see usernames of people who comment (public info only).</p>
                                </Checkbox>
                            </Card>
                        </div>

                        <p style={{ marginTop: 16, fontSize: 12, color: "#888", textAlign: "center" }}>
                            They cannot see your DMs or access your account settings.
                        </p>
                    </div>
                )}
            </Modal>

            {/* Edit Access Permissions Modal */}
            <Modal
                title="Edit Access Permissions"
                open={editPermissionsModalOpen}
                onCancel={() => setEditPermissionsModalOpen(false)}
                footer={[
                    <Button key="cancel" onClick={() => setEditPermissionsModalOpen(false)}>
                        Cancel
                    </Button>,
                    <Button key="save" type="primary" loading={updatingAccess} onClick={handleUpdatePermissions}>
                        Save Changes
                    </Button>
                ]}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 20 }}>
                    <Card size="small">
                        <Checkbox
                            checked={editPermissions.view_automation}
                            onChange={(e) => {
                                if (!e.target.checked) {
                                    setEditPermissions({ ...editPermissions, edit_automation: false, view_automation: e.target.checked })
                                }
                                else {
                                    setEditPermissions({ ...editPermissions, view_automation: e.target.checked })
                                }
                            }}
                        >
                            <span style={{ fontWeight: 500 }}>View Automation Configuration</span>
                            <p style={{ margin: 0, color: "#666", fontSize: 12 }}>Can see how automation is set up.</p>
                        </Checkbox>
                    </Card>

                    <Card size="small">
                        <Checkbox
                            checked={editPermissions.edit_automation}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setEditPermissions({ ...editPermissions, edit_automation: e.target.checked, view_automation: e.target.checked })
                                } else {
                                    setEditPermissions({ ...editPermissions, edit_automation: e.target.checked })
                                }
                            }}
                        >
                            <span style={{ fontWeight: 500 }}>Edit Automation</span>
                            <p style={{ margin: 0, color: "#666", fontSize: 12 }}>Can modify the automation messages and settings.</p>
                        </Checkbox>
                    </Card>

                    <Card size="small">
                        <Checkbox
                            checked={editPermissions.view_contacts}
                            disabled={true}
                            onChange={(e) => setEditPermissions({ ...editPermissions, view_contacts: e.target.checked })}
                        >
                            <span style={{ fontWeight: 500 }}>View Comments (Public Data)</span>
                            <p style={{ margin: 0, color: "#666", fontSize: 12 }}>Can see usernames of people who comment.</p>
                        </Checkbox>
                    </Card>
                </div>
            </Modal>

        </div >
    )

}

export default Automations;
